import React from 'react';
import Header from './components/header';
import Footer from './components/footer';
import { Flex } from '@chakra-ui/react';

export default function RootLayout({ children }) {

  return (
    <>
      <Header />
      <Flex
        backgroundColor={"white"}
        flexDirection="column"
        width="100%"
        flex="1"
        minHeight="0"
      >
        {children}
      </Flex>
      <Footer />
    </>
  )
}
